module.exports = __webpack_public_path__ + "img/graduate.82054a38.jpg";